import type { SpinnerProps as FluentSpinnerProps } from '@fluentui/react-components';
import { Spinner as FluentSpinner } from '@fluentui/react-components';
import type { FC } from 'react';
import React from 'react';

import { useTheme } from '../../../util/theme';
import type { OmitStyling } from '../types';

type SpinnerProps = Omit<OmitStyling<FluentSpinnerProps>, 'appearance'>;

export const Spinner: FC<SpinnerProps> = (props) => {
  const theme = useTheme();
  const appearance = theme.isInverted ? 'inverted' : 'primary';

  return <FluentSpinner {...props} appearance={appearance} />;
};
